module.exports = __webpack_public_path__ + "img/alpha-tauri.0626ca7e.jpg";